import "./checkbox-3.css";

const CheckBox3 = ({ id, title, checked, onChange }) => {
  return (
    <div className="checkbox-wrapper-34">
      <input className="tgl tgl-ios" id="toggle-34" type="checkbox" />
      <label className="tgl-btn" htmlFor="toggle-34"></label>
    </div>
  );
};

export default CheckBox3;
